import {Grid, Skeleton, Typography} from "@mui/material"
import {Box} from "@mui/system"
import {FC} from "react"
import {ArticleChevronIcon} from "../../../assets"
import {useConfigProvider} from "../../../config"
import {
  articleTitleBackgroundColours,
  articleTitleTextColours,
} from "../../../theme"

type Props = {
  imageUrl?: string
  parameters?: {[key: string]: string}
  title?: string
  loading: boolean
}

const ArticleBanner: FC<Props> = (props) => {
  const {imageUrl, loading, parameters, title} = props
  const {cmsImageUrl} = useConfigProvider()

  return (
    <Grid size={12} position="relative" display="flex" height="220px">
      {loading ? (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={220}
          sx={{
            mixBlendMode: "linear-burn",
            backgroundBlendMode: "linear-burn",
            backgroundImage:
              "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
            padding: "79px 574px 47px 25px",
          }}
        />
      ) : (
        <img
          id="thoughtPiecesFullPageBanner"
          src={cmsImageUrl + imageUrl}
          style={{maxHeight: "220px", width: "100%", objectFit: "cover"}}
        />
      )}

      <Box
        style={{height: "100%", width: "50%", top: 0, left: 0}}
        display={"flex"}
        position={"absolute"}
      >
        {loading ? (
          <>
            <Skeleton
              variant="rectangular"
              sx={{
                position: "absolute",
                left: "25px",
                top: "79px",
                bottom: "79px",
                width: "33px",
                height: "62px",
              }}
            />
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              gap={"1px"}
              style={{
                position: "absolute",
                left: "71px",
                top: "92px",
                height: "auto",
              }}
            >
              <Skeleton
                variant="rectangular"
                sx={{
                  width: "476px",
                  height: "40px",
                  mixBlendMode: "linear-burn",
                  backgroundBlendMode: "linear-burn",
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: "476px",
                  height: "40px",
                  mixBlendMode: "linear-burn",
                  backgroundBlendMode: "linear-burn",
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
            </Box>
          </>
        ) : (
          parameters && (
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1.5}
              style={{height: "100%", paddingLeft: "25px"}}
            >
              {parameters["ChevronEnabled"] === "true" && (
                <ArticleChevronIcon fill={parameters["ArticleTitleStyle"]} />
              )}
              <Typography
                variant="h4"
                style={{flex: "2", fontSize: "18px", fontWeight: "600"}}
              >
                <span
                  style={{
                    color:
                      articleTitleTextColours[parameters["ArticleTitleStyle"]],
                    backgroundColor:
                      articleTitleBackgroundColours[
                        parameters["ArticleTitleStyle"]
                      ],
                    padding: "0 .3125rem",
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                    lineHeight: "1.625rem",
                  }}
                >
                  {title}
                </span>
              </Typography>
            </Box>
          )
        )}
      </Box>
    </Grid>
  )
}

export default ArticleBanner
